import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteProjectFile as deleteProjectFileAPI } from '@/api/v4/project-files.api';
import { QueryKey } from '@/config/query-client';

import { projectIdState } from '../../projects/project.state';
import { useAtomValue } from 'jotai';

export const useDeleteProjectFile = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);

  const mutation = useMutation({
    mutationFn: deleteProjectFileAPI,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectFiles] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectActionsInfo],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  const deleteProjectFile = (fileId: string) => {
    if (!projectId) return;

    return mutation.mutateAsync({ projectId, fileId });
  };

  return {
    deleteProjectFile,
    isError: mutation.isError,
  };
};
